import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  MenuItem,
  TextField,
  CircularProgress,
  FormControlLabel,
  Switch,
  Autocomplete,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../DataLayouts/Header";
import toast from "react-hot-toast";
import { fetchOrganizationEmployee } from "../../../Apis/Employee-api";
import {
  fetchLeaveCategory,
  fetchLeaveReason,
  fetchLeaveTypes,
} from "../../../Apis/Leave-api";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../../../Configurations/Urls";
import axios from "axios";
import dayjs from "dayjs";
import { fetchOrganizationDesignation } from "../../../Apis/Designation-api";
import {
  fetchOrganizationDepartment,
  fetchOrganizationLocation,
} from "../../../Apis/DepartmentLocation-api";
import { fetchOrganizationEmploymentStatus } from "../../../Apis/OrganizationEmploymentStatus";
import { fetchOrganizationEmploymentTypes } from "../../../Apis/Organization-Employement-types";
import {
  fetchWorkShift,
  fetchWorkShiftTypes,
} from "../../../Apis/Workshift-api";
import { fetchBusinessRegistrationType } from "../../../Apis/Registration-api";
import { fetchOrgBusinessOwnershipType } from "../../../Apis/BusinessOwnershipType";

function EmployeeLeaveEntitlmentForm({ mode }) {
  const { id } = useParams();
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const [formData, setFormData] = useState({
    organization_location_id: "",
    organization_department_id: "",
    organization_designation_id: "",
    organization_employment_type_id: "",
    organization_employment_status_id: "",
    organization_work_shift_id: "",
    organization_work_shift_type_id: "",
    organization_business_registration_type_id: "",
    organization_business_ownership_type_id: "",
    organization_leave_type_id: "",
    entitled_days: "",
    carry_forward_days: "",
    entitlement_period: "",
    encashment_allowed: "",
    max_accumulated_days: "",
    requires_approval: "",
    priority_level: "",
    is_active: "",
    created_by: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);

  const [location, setLocation] = useState([]);
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [empType, setEmpType] = useState([]);
  const [empStatus, setEmpStatus] = useState([]);
  const [workshift, setWorkShift] = useState([]);
  const [workshiftType, setWorkShiftType] = useState([]);

  const [businessRegType, setBusinessRegType] = useState([]);

  const [businessOwnType, setBusinessOwnType] = useState([]);
  const [leavetype, setLeaveType] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    {
      fetchOrganizationDepartment(org?.organization_id)
        .then((data) => {
          setDepartment(data?.Departments);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);
  console.log("organizationdepartment", department);

  useEffect(() => {
    {
      fetchOrganizationLocation(org?.organization_id)
        .then((data) => {
          setLocation(data?.locations);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);
  console.log("organizationdepartment", department);

  useEffect(() => {
    const fetchDepartmentDesignation = async () => {
      if (!formData?.organization_department_id || !org?.organization_id)
        return;

      try {
        const res = await axios.get(
          `${MAIN_URL}/api/department-designation/all`,
          {
            params: {
              department_id: formData.organization_department_id,
              organization_id: org?.organization_id,
            },
          }
        );
        setDesignation(res?.data?.data);
      } catch (error) {
        console.error("Failed to fetch department designation", error);
      }
    };

    fetchDepartmentDesignation();
  }, [formData?.organization_department_id, org?.organization_id]);

  console.log("designation is ", designation);

  useEffect(() => {
    {
      fetchLeaveTypes(org?.organization_id)
        .then((data) => {
          setLeaveType(data?.leavetypes?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, []);

  console.log("emptypes ", empType);

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrganizationLocation(org?.organization_id)
        .then((data) => {
          setLocation(data?.locations);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrganizationEmploymentTypes(org?.organization_id)
        .then((data) => {
          setEmpType(data?.employemtType?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrganizationEmploymentStatus(org?.organization_id)
        .then((data) => {
          setEmpStatus(data?.status?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchWorkShift(org?.organization_id)
        .then((data) => {
          setWorkShift(data?.workshifts?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchWorkShiftTypes(org?.organization_id)
        .then((data) => {
          setWorkShiftType(data?.workshifttype?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchBusinessRegistrationType(org?.organization_id)
        .then((data) => {
          setBusinessRegType(data?.organizationbusinessregistrationtype?.data);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrgBusinessOwnershipType(org?.organization_id)
        .then((data) => {
          setBusinessOwnType(data?.businessownershiptype);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, [org]);

  useEffect(() => {
    let getdataById = async () => {
      const response = await axios.get(
        `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-entitlements/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      let a = response?.data?.leaveEntitle;
      setFormData(a);
      setLoading(false);
    };
    if ((mode === "edit" || mode ==="view" )&& id) {
      setLoading(true);
      getdataById();
    }
  }, [mode, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSwitchChange = (field) => (e) => {
    const { checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [field]: checked ? 1 : 0, // Always store as 1/0
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_leave_type_id) {
      errors.organization_leave_type_id = "Leave Type is required.";
    }

    if (!formData.entitled_days) {
      errors.entitled_days = "Entitle days  are required.";
    }

    if (!formData.entitlement_period) {
      errors.entitlement_period = "Entitlement period is required.";
    }
    if (!formData.max_accumulated_days) {
      errors.max_accumulated_days = "Max. accumulated days are required.";
    }
    if (!formData.carry_forward_days) {
      errors.carry_forward_days = "Carry forward days are required.";
    }

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setbtnLoading(true);

    try {
      if (mode === "edit") {
        await axios.put(
          `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-entitlements/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-entitlements`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      toast.success(
        mode === "edit"
          ? "Employee Leave Entitlement Updated!"
          : "Employee Leave Entitlement Created!"
      );
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors = err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors)
          .map((arr) => arr[0])
          .join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setbtnLoading(false);
    }
  };

  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Employee Leave Entitlement"}
        addMessage={"Employee Leave Entitlement"}
        homeLink={"/leave/employee-entitlements"}
        homeText={"Employee Leaves Entitlement"}
      />
      {loading ? (
        <Grid container spacing={2}>
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>
               

               
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // centers the row
                    gap: 2, // space between fields
                    width: "100%", // ensures proper centering
                  }}
                >
                    <Autocomplete
                  fullWidth
                  options={leavetype || []}
                  getOptionLabel={(option) => option.leave_type_name || ""}
                  value={
                    leavetype?.find(
                      (option) =>
                        option.organization_leave_type_id ===
                        formData.organization_leave_type_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_leave_type_id",
                        value: newValue?.organization_leave_type_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || leavetype?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Leave Type"
                      error={!!formErrors.organization_leave_type_id}
                      helperText={formErrors.organization_leave_type_id}
                      required
                      fullWidth
                    />
                  )}
                />

                <TextField
                  select
                  fullWidth
                  label="Entitlement Period"
                  name="entitlement_period"
                  disabled = {mode === "view"}
                  value={formData?.entitlement_period}
                  onChange={(e) => {
                    handleChange(e);
                    handleChange({
                      target: { name: "entitled_days", value: "" },
                    });
                    handleChange({
                      target: { name: "max_accumulated_days", value: "" },
                    });
                    handleChange({
                      target: { name: "carry_forward_days", value: "" },
                    });
                  }}
                  error={!!formErrors.entitlement_period}
                  helperText={formErrors.entitlement_period}
                  required
                >
                  <MenuItem value="annual">Annual</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                  <MenuItem value="quarterly">Quarterly</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  type="number"
                  label="Entitled Days"
                  name="entitled_days"
                    disabled = {mode === "view"}
                  value={formData?.entitled_days || ""}
                  onChange={(e) => {
                    let value =
                      e.target.value === "" ? "" : parseInt(e.target.value, 10);

                    let maxDays = 366;
                    if (formData?.entitlement_period === "annual")
                      maxDays = 366;
                    else if (formData?.entitlement_period === "monthly")
                      maxDays = 31;
                    else if (formData?.entitlement_period === "quarterly")
                      maxDays = 92;
                    else if (formData?.entitlement_period === "custom")
                      maxDays = 366;

                    if (value !== "" && value < 0) value = 0;
                    if (value !== "" && value > maxDays) value = maxDays;

                    handleChange({
                      target: {
                        name: e.target.name,
                        value,
                      },
                    });
                  }}
                  error={!!formErrors.entitled_days}
                  helperText={formErrors.entitled_days}
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: "1",
                    min: "0",
                    max:
                      formData?.entitlement_period === "annual"
                        ? 366
                        : formData?.entitlement_period === "monthly"
                          ? 31
                          : formData?.entitlement_period === "quarterly"
                            ? 92
                            : formData?.entitlement_period === "custom"
                              ? 365
                              : 366,
                  }}
                />

                </Box>



                 
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // centers the row
                    gap: 2, // space between fields
                    width: "100%", // ensures proper centering
                  }}
                >

                  
                <TextField
                  fullWidth
                  type="number"
                  label="Max Accumulated Days"
                  name="max_accumulated_days"
                    disabled = {mode === "view"}
                  value={formData?.max_accumulated_days || ""}
                  onChange={(e) => {
                    let value =
                      e.target.value === "" ? "" : parseInt(e.target.value, 10);

                    let maxDays = 366;
                    if (formData?.entitlement_period === "annual")
                      maxDays = 366;
                    else if (formData?.entitlement_period === "monthly")
                      maxDays = 31;
                    else if (formData?.entitlement_period === "quarterly")
                      maxDays = 92;
                    else if (formData?.entitlement_period === "custom")
                      maxDays = 366;

                    if (value !== "" && value < 0) value = 0;
                    if (value !== "" && value > maxDays) value = maxDays;

                    handleChange({
                      target: {
                        name: e.target.name,
                        value,
                      },
                    });
                  }}
                  error={!!formErrors.max_accumulated_days}
                  helperText={formErrors.max_accumulated_days}
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: "1",
                    min: "0",
                    max:
                      formData?.entitlement_period === "annual"
                        ? 366
                        : formData?.entitlement_period === "monthly"
                          ? 31
                          : formData?.entitlement_period === "quarterly"
                            ? 92
                            : formData?.entitlement_period === "custom"
                              ? 365
                              : 366,
                  }}
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Carry Forward Days"
                    disabled = {mode === "view"}
                  name="carry_forward_days"
                  value={formData?.carry_forward_days || ""}
                  onChange={(e) => {
                    let value =
                      e.target.value === "" ? "" : parseInt(e.target.value, 10);

                    let maxDays = 366;
                    if (formData?.entitlement_period === "annual")
                      maxDays = 366;
                    else if (formData?.entitlement_period === "monthly")
                      maxDays = 31;
                    else if (formData?.entitlement_period === "quarterly")
                      maxDays = 92;
                    else if (formData?.entitlement_period === "custom")
                      maxDays = 366;

                    if (value !== "" && value < 0) value = 0;
                    if (value !== "" && value > maxDays) value = maxDays;

                    handleChange({
                      target: {
                        name: e.target.name,
                        value,
                      },
                    });
                  }}
                  error={!!formErrors.carry_forward_days}
                  helperText={formErrors.carry_forward_days}
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: "1",
                    min: "0",
                    max:
                      formData?.entitlement_period === "annual"
                        ? 366
                        : formData?.entitlement_period === "monthly"
                          ? 31
                          : formData?.entitlement_period === "quarterly"
                            ? 92
                            : formData?.entitlement_period === "custom"
                              ? 365
                              : 366,
                  }}
                />

                </Box>


                   <FormControlLabel
                  control={
                    <Switch
                    disabled={mode === "view"}
                      checked={
                        formData?.requires_approval === 1 ||
                        formData?.requires_approval === "1"
                      }
                      onChange={handleSwitchChange("requires_approval")}
                      color="primary"
                    />
                  }
                  label="Required Approval"
                />

                <FormControlLabel
                  control={
                    <Switch
                      disabled = {mode === "view"}
                      checked={
                        formData?.encashment_allowed === 1 ||
                        formData?.encashment_allowed === "1"
                      }
                      onChange={handleSwitchChange("encashment_allowed")}
                      color="primary"
                    />
                  }
                  label="Encashment Allowed"
                />



                 
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // centers the row
                    gap: 2, // space between fields
                    width: "100%", // ensures proper centering
                  }}
                >

                 

                <Autocomplete
                  fullWidth
                  options={department || []}
                  getOptionLabel={(option) => option.department_name || ""}
                  value={
                    department?.find(
                      (option) =>
                        option.organization_department_id ===
                        formData.organization_department_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_department_id",
                        value: newValue?.organization_department_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || department?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Department"
                      error={!!formErrors.organization_department_id}
                      helperText={formErrors.organization_department_id}
                      required
                      fullWidth
                    />
                  )}
                />

                              
                <Autocomplete
  fullWidth
  options={designation || []}
  getOptionLabel={(option) => option?.designation_name || ""}
  value={
    designation?.find(
      (d) => d.organization_designation_id === formData?.organization_designation_id
    ) || null
  }
  onChange={(event, newValue) => {
    handleChange({
      target: {
        name: "organization_designation_id",
        value: newValue?.organization_designation_id || "",
      },
    });
  }}
  disabled={designation?.length === 0}
  isOptionEqualToValue={(option, value) =>
    option.organization_designation_id === value.organization_designation_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Designation Name"
      name="organization_designation_id"
      error={!!formErrors.organization_designation_id}
      helperText={formErrors.organization_designation_id}
      fullWidth
    />
  )}
/>


            
<Autocomplete
  fullWidth
  options={location || []}
  getOptionLabel={(option) => option.location_name || ""}
  value={
    location?.find(
      (option) =>
        option.organization_location_id ===
        formData.organization_location_id
    ) || null
  }
  onChange={(event, newValue) => {
    handleChange({
      target: {
        name: "organization_location_id",
        value: newValue?.organization_location_id || "",
      },
    });
  }}
  disabled={
    mode === "view" ||
    !formData.organization_designation_id ||
    location?.length === 0
  }
  isOptionEqualToValue={(option, value) =>
    option.organization_location_id === value.organization_location_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Location"
      error={!!formErrors.organization_location_id}
      helperText={formErrors.organization_location_id}
      required
      fullWidth
    />
  )}
/>



                </Box>

              


              
 
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // centers the row
                    gap: 2, // space between fields
                    width: "100%", // ensures proper centering
                  }}
                >

                   <Autocomplete
                  fullWidth
                  options={empType || []}
                  getOptionLabel={(option) => option.employment_type_name || ""}
                  value={
                    empType?.find(
                      (option) =>
                        option.organization_employment_type_id ===
                        formData.organization_employment_type_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_employment_type_id",
                        value: newValue?.organization_employment_type_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || empType?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employment Type"
                      error={!!formErrors.organization_employment_type_id}
                      helperText={formErrors.organization_employment_type_id}
                      required
                      fullWidth
                    />
                  )}
                />

              

                <Autocomplete
                  fullWidth
                  options={empStatus || []}
                  getOptionLabel={(option) =>
                    option.employment_status_name || ""
                  }
                  value={
                    empStatus?.find(
                      (option) =>
                        option.organization_employment_status_id ===
                        formData.organization_employment_status_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_employment_status_id",
                        value:
                          newValue?.organization_employment_status_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || empStatus?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employment Status"
                      error={!!formErrors.organization_employment_status_id}
                      helperText={formErrors.organization_employment_status_id}
                      required
                      fullWidth
                    />
                  )}
                />

              

                <Autocomplete
                  fullWidth
                  options={workshift || []}
                  getOptionLabel={(option) => option.work_shift_name || ""}
                  value={
                    workshift?.find(
                      (option) =>
                        option.organization_work_shift_id ===
                        formData.organization_work_shift_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_work_shift_id",
                        value: newValue?.organization_work_shift_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || workshift?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Exit Reason Category"
                      error={!!formErrors.organization_work_shift_id}
                      helperText={formErrors.organization_work_shift_id}
                      required
                      fullWidth
                    />
                  )}
                />

                </Box>
 

               
               

              
              

                <Autocomplete
                  fullWidth
                  options={workshiftType || []}
                  getOptionLabel={(option) =>
                    option.work_shift_type_name || ""
                  }
                  value={
                    workshiftType?.find(
                      (option) =>
                        option.organization_work_shift_type_id ===
                        formData.organization_work_shift_type_id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "organization_work_shift_type_id",
                        value: newValue?.organization_work_shift_type_id || "",
                      },
                    });
                  }}
                  disabled={mode === "view" || workshiftType?.length === 0}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="WorkShift Type"
                      error={!!formErrors.organization_work_shift_type_id}
                      helperText={formErrors.organization_work_shift_type_id}
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid container spacing={2} mt={2}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={handleSubmit}
                    disabled={loading || btnLoading || mode === "view"}
                    sx={{
                      borderRadius: 2,
                      minWidth: 120,
                      textTransform: "capitalize",
                      fontWeight: 500,
                    }}
                  >
                    {loading || btnLoading ? (
                      <CircularProgress size={22} sx={{ color: "#fff" }} />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>

                {mode === "edit" && (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      size="medium"
                      onClick={() => navigate(-1)}
                      sx={{
                        borderRadius: 2,
                        minWidth: 120,
                        textTransform: "capitalize",
                        fontWeight: 500,
                        backgroundColor: "#1976d2",
                        "&:hover": { backgroundColor: "#115293" },
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default EmployeeLeaveEntitlmentForm;
